import React from 'react'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'

import Grid from '@material-ui/core/Grid'

import Recherche from 'EurestoComponents/Recherche'

import Card from '../../Component/Card'
import Search from '../Search/insee'

export default (props) => {

  const columns = [
    { Header: 'id', accessor: 'id', show: false },
    {
      Header:
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
              alignItems={'center'}>
          <b>Dénomination Usuelle</b>
        </Grid>,
      id: 'nom',
      accessor: 'nom',
      sortable: false,
      minWidth: 130,
      Cell: row => {
        return (
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
                alignItems={'center'}>
            <b className={row.original.type === Constants.access.ETABLISSEMENT && row.original.licence_active !== 1 && 'EurestoError--text' || ''}>{row.value}</b>
          </Grid>
        )
      },
    },
    {
      Header: <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
              alignItems={'center'}>
          <b>Siret</b>
        </Grid>,
      id: 'siret',
      accessor: 'siret',
      sortable: false,
      minWidth: 130,
    },
    {
      Header:
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
              alignItems={'center'}>
          <b>Ville</b>
        </Grid>,
      id: 'ville',
      accessor: 'ville',
      sortable: false,
      minWidth: 130,
    },
    {
      Header:
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
              alignItems={'center'}>
          <b>Code Postal</b>
        </Grid>,
      id: 'cp',
      accessor: 'cp',
      sortable: false,
      minWidth: 130,
    },
  ]
  return (
    <Recherche
      loading={props.loading}
      showSearch={props.showSearch}
      searchComponent={<Search search={props.search || 'insee_' + (props.name || '') + User.Entite.get().id}/>}
      view={props.view}
      data={props.data}
      type={props.type}
      style={props.style}
      onClick={props.onClick}
      card={Card}
      columns={columns}
      search={props.search || 'insee_' + (props.name || '') + User.Entite.get().id}
    />
  )

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Table/insee.js